module.exports = __webpack_public_path__ + "assets/pdf/vino-rosado.35566be4.pdf";